<template>
    <Head title="ユーザー計測" />

    <BreezeAuthenticatedLayout>

      <main class="container">
        <AdminNav />
        <div class="py-12">
          <h1 style="font-size: 20px; font-weight:bold; margin-top: 42px;">ユーザー計測</h1>

          <div class="tracking">
            <div class="tracking_row">

              <div class="tracking_row_box">
                <h2 class="tracking_row_box_heading">MAU（Monthly Active Users）<br>月間利用ユーザ数</h2>

                <div class="tracking_row_box_content">
                  <table>
                    <tbody>
                      <tr v-for="mau in project_users.mau" >
                        <td class="px-6 py-4 whitespace-nowrap">
                          {{ trimDate(mau.start_date) }} 〜
                        </td>
                        <td>
                          ：{{ countArr(mau) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="tracking_row_box">
                <h2 class="tracking_row_box_heading">WAU（Weekly Active Users）<br>週間利用ユーザ数</h2>
                <div class="tracking_row_box_content">
                  <table>
                    <tbody>
                      <tr v-for="wau in project_users.wau" >
                        <td class="px-6 py-4 whitespace-nowrap">
                          {{ trimDate(wau.start_date) }} 〜
                        </td>
                        <td>
                          ：{{ countArr(wau) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="tracking_row_box">
                <h2 class="tracking_row_box_heading">DAU（Daily Active Users）<br>日毎利用ユーザ数</h2>
                <div class="tracking_row_box_content">
                  <table>
                    <tbody>
                      <tr v-for="dau in project_users.dau" >
                        <td class="px-6 py-4 whitespace-nowrap">
                          {{ trimDate(dau.start_date) }}
                        </td>
                        <td>
                          ：{{ countArr(dau) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div style="height: 60px;"></div>

            <div class="tracking">
              <div class="tracking_row">
                <div class="tracking_row_box">
                  <h2 class="tracking_row_box_heading">日毎登録ユーザ数</h2>
                  <div class="tracking_row_box_content">
                    <table>
                      <tbody>
                        <tr v-for="count_user in count_users" >
                          <td class="px-6 py-4 whitespace-nowrap">
                            {{ trimDate(count_user.date) }}
                          </td>
                          <td>
                            ：{{ count_user.count }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="tracking_row_box">
                  <h2 class="tracking_row_box_heading">総ユーザ数</h2>
                  <div class="tracking_row_box_content">
                    <table>
                      <tbody>
                        <tr v-for="count_user in count_users" >
                          <td class="px-6 py-4 whitespace-nowrap">
                            {{ trimDate(count_user.date) }}
                          </td>
                          <td>
                            ：{{ count_user.total }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
        <Side />
      </main>
    </BreezeAuthenticatedLayout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue'
import { Head, Link } from '@inertiajs/inertia-vue3';
import Side from '@/Shared/Side'
import AdminNav from '@/Shared/AdminNav'

export default {
  components: {
    BreezeAuthenticatedLayout,
    Head,
    Link,
    Side,
    AdminNav
  },
  props: {
    // users: Array
    project_users: Array,
    count_users: Array
  },
  methods: {
    countArr(arr) { // WAU要素数取得
      return Object.keys(arr).length - 1
    },
    trimDate(date) {
      return date.substring(0, 10);
    }
  }
}
</script>
